import lib from '@/library'

const state = {
  meetings: [],
  areMeetingsLoaded: false,
  timeoutFetchMeetings: undefined,
  periodicallyFetchMeetingsDelay: 30000
}

const getters = {
  getMeetings (state) {
    return state.meetings
  },
  getAreMeetingsLoaded (state) {
    return state.areMeetingsLoaded
  },
  getMeetingsWithOpenRaces (state) {
    return (state.meetings && state.meetings.filter(meeting =>
      meeting.races && meeting.races.filter(race => race.generalstatuscode === 'OPEN').length > 0)) || []
  }
}

const actions = {
  fetchMeetings (context) {
    // context.commit('setAreMeetingsLoaded', false)
    window.clearTimeout(context.state.timeoutFetchMeetings)

    lib.kansas.totedailyracecard({
      date: 'TODAY',
      language: 'UK' // TODO: change to configured language once it is optimized
    }).then(response => {
      context.commit('setMeetings', response.data.meetings || [])
      context.commit('setAreMeetingsLoaded', true)

      context.state.timeoutFetchMeetings = window.setTimeout(() => {
        context.dispatch('fetchMeetings')
      }, context.state.periodicallyFetchMeetingsDelay)
    }).catch(() => {
      context.commit('setMeetings', [])
      context.commit('setAreMeetingsLoaded', true)

      context.state.timeoutFetchMeetings = window.setTimeout(() => {
        context.dispatch('fetchMeetings')
      }, context.state.periodicallyFetchMeetingsDelay)
    })
  }
}

const mutations = {
  setMeetings (state, meetings) {
    state.meetings = meetings || []
  },
  setAreMeetingsLoaded (state, value) {
    state.areMeetingsLoaded = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/meeting.js